import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-the-pitch',
  templateUrl: './the-pitch.component.html',
  styleUrls: ['./the-pitch.component.css']
})
export class ThePitchComponent implements OnInit {
  episode1Id: string = "ub2eDAEkN90";
  episode2Id: string = "eYHK9Wrecrk";
  episode3Id: string = "eXJVmD0yReo";
  episode4Id: string = "LK6zG3RwlEc";

  galleryItems = [
    { id: 1, type: 'youtube', url: 'ub2eDAEkN90', title: 'Peloton for Horses | Would You Invest?' },
    { id: 2, type: 'youtube', url: 'eYHK9Wrecrk', title: 'Gnara: Peeing Outside Made Easy'},
    { id: 3, type: 'youtube', url: 'eXJVmD0yReo', title: 'Potato Chip Chef: It\'s Easily a Billion Dollar Business!'},
    { id: 4, type: 'youtube', url: 'LK6zG3RwlEc', title: 'Stanford Engineer: Gecko-Inspired Space Velcro'}
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
